/**
 * One second, the gap that keeps a period and the window it is compared against from sharing an instant.
 *
 * Without it the comparison closes exactly where the period opens - `end - range` IS `start` - and a
 * payment landing there is counted on both sides of every badge.
 */
export const SEPARATION_MS = 1000;

export type PreviousPeriod = {
  previousPeriodStartDate: Date;
  previousPeriodEndDate: Date;
};

/**
 * The window immediately before a period, of equal length, ending one second short of it.
 *
 * This arithmetic had been written three times - parsePeriodRange for the named ranges, CustomPeriodRange
 * for the modal, resolveHandedOverPeriod for a link that carried none - and only the first left the gap.
 * The other two closed the comparison on the instant the period opened, so the same fortnight compared
 * against a different window depending on how the producer had selected it. One implementation is the
 * point: the separation is easy to leave out and impossible to notice, since nothing fails and the badge
 * is merely wrong by whatever landed on the boundary.
 */
export const derivePreviousPeriod = (start: number, end: number): PreviousPeriod => {
  const previousPeriodEndDate = new Date(start - SEPARATION_MS);

  return {
    previousPeriodStartDate: new Date(
      previousPeriodEndDate.getTime() - (end - start),
    ),
    previousPeriodEndDate,
  };
};
